import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

/**
 * Call once—only if the visitor has the Live‑Chat product.
 */
export const ensureAnonAuth = () => {
    if (typeof window !== 'undefined') {
        (async () => {
            try {
                // Dynamically import firebase/auth
                // const { getAuth, signInAnonymously } = await import('firebase/auth');

                // Initialize Firebase Authentication
                const auth = getAuth(app);

                // Anonymous authentication
                await signInAnonymously(auth);
                // User is signed in anonymously, and you can now securely access Firestore
            } catch (error) {
                console.error("Error signing in anonymously:", error);
            }
        })();
    }
};

export default db;